import { render, staticRenderFns } from "./TotalCount.vue?vue&type=template&id=b6931a7c&"
import script from "./TotalCount.vue?vue&type=script&lang=js&"
export * from "./TotalCount.vue?vue&type=script&lang=js&"
import style0 from "./TotalCount.vue?vue&type=style&index=0&id=b6931a7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports